// Blow Exhaust JS

$(document).ready(function() {
 
 	 var screenSize = $( window ).width();

 	//owl carousel
	$("#homepage-slider").owlCarousel({ 
	  autoPlay: 5000, //Set AutoPlay to 3 seconds
      navigation : false, // Show next and prev buttons
      slideSpeed : 300,
      paginationSpeed : 400,
      singleItem:true
	});
 
	// currency picker select (update other currency selector values)
	$(".currency-picker").on("change", function(){
		$(".currency-picker").val( $(this).val() );
	});

	// open modal in product page. bulk discount
	$("#bulk-modal").on("click", function(){
		$("body").addClass("no-scroll");
		$(".blow-modal-overlay").fadeIn(300);
		$(".blow-modal-container").fadeIn(300);
	});

	$(".blow-modal-overlay, .blow-modal-overlay i").on("click", function(){
		$("body").removeClass("no-scroll");
		$(".blow-modal-overlay").fadeOut(300);
		$(".blow-modal-container").fadeOut(200);
	});

  $('body').on('click', '[name="checkout"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        $("body").addClass("no-scroll");
		$(".blow-modal-overlay").fadeIn(300);
		$(".modal-agree").fadeIn(300);
        return false;
      }
    });
  

	// CUSTOM ADDED CODE TO DETECT COUNTY AND SET CURRENCY
	jQuery.ajax({
	  url: '//freegeoip.net/json/',
	  type: 'POST',
	  dataType: 'jsonp',
	  success: function(location) {
	    // If the visitor is browsing from Australia and New Zealand.
	    if (location.country_code === 'AU' || location.country_code === 'NZ') {
	      // currency picker select (update other currency selector values)
	      $(".currency-picker").val('AUD').change();
	    }
	  }
	});
	

});




